module.exports = __webpack_public_path__ + "static/img/Draw_Games_Banner_Mobile.227804f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/banners/Draw_Games_Banner_Mobile.jpg
// module id = nbXP
// module chunks = 1